export const DATE_FORMATS = {
  DEFAULT: "MM-dd HH:mm:ss",
  SHORT_DATE: "MM-dd",
  FULL_DATE: "yyyy-MM-dd",
  TIME_ONLY: "HH:mm:ss",
  FULL_DATE_TIME: "yyyy-MM-dd HH:mm:ss",
  READABLE: "MMM dd, yyyy HH:mm",
};
